import {
  AlgorithmTargetFormDataType,
  AlgorithmTargetMutationDtoType,
  AlgorithmTargetValidFormDataType,
} from './types';
import { AlgorithmTargetValidFormDataSchema } from './AlgorithmTargetValidFormDataSchema';
import { AlgorithmTargetFormDataSchema } from './AlgorithmTargetFormDataSchema';
import { AlgorithmTargetMutationDtoSchema } from './AlgorithmTargetsMutationDtoSchema';

export class AlgorithmTargetSchema {
  static parseFormData<Dto>(data: Dto): AlgorithmTargetFormDataType {
    return AlgorithmTargetFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<AlgorithmTargetValidFormDataType>
  >(validFormData: ValidFormData): AlgorithmTargetMutationDtoType {
    return AlgorithmTargetMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = AlgorithmTargetValidFormDataSchema;
}
